// run-end.ts — (B105; planning 10-22 23:55) a run that has ENDED says why, in the Run Inspector, instead of the gate it
// waited at before. A failed run's gate notes ("Why the engine stopped here: … no image has been made") and its decide
// boxes are stale once it has moved past the gate and failed; its reason is the failed step's category (persist_failed).

export const RUN_ENDED = new Set(["failed", "cancelled", "completed", "succeeded", "stopped"]);
export const runEnded = (status: string | null | undefined): boolean => RUN_ENDED.has(String(status ?? ""));

/** Pure: the line an ended run shows (null while it runs, or when it completed). A failed run's reason is its latest failed
 *  step's category, and where. */
export function endReasonLine(status: string, steps: { stepId: string; beatId: string | null; status: string; failureCategory: string | null; endedAt: string | null }[]): string | null {
  if (status === "failed") {
    const failed = steps.filter((s) => s.status === "failed" && s.failureCategory)
      .sort((a, b) => String(b.endedAt ?? "").localeCompare(String(a.endedAt ?? "")))[0];
    return failed ? `Why the run ended: it failed, ${failed.failureCategory} (at ${failed.stepId}${failed.beatId ? ` ${failed.beatId}` : ""}).`
      : "Why the run ended: it failed, and no step names a reason.";
  }
  if (status === "cancelled") return "Why the run ended: it was cancelled.";
  if (status === "stopped") return "Why the run ended: it was stopped.";
  return null;
}

/** (B105; planning 10-22 23:56) the Inspector's Abandon is the orchestrator's cancel (POST /ops/runs/:id/cancel), the same
 *  one Operations and the dry run's banner use: it closes the run's gates and unfinished steps and cascades to the video's
 *  status and credits. The workers' own abandon (fail it off to free a slot) didn't stop a run with a step in flight. */
export const ABANDON_ASK = "Abandon this run? It's cancelled through the orchestrator: its gates and unfinished steps close, and the video's status and credits follow. Why? (required — recorded with the cancel)";
